<template>
    <div
        @click="onClick"
        class="start-test-btn d-flex align-items-center justify-content-center pointer"
    >
        <BaseIcon class="mr-3" name="check-circle" size="lg" />
        <h3 class="mb-0 text-center white">
            {{ label || $t('tests.cute.startTest') }}
        </h3>
    </div>
</template>

<script>
export default {
    name: 'StartTestButton',
    props: {
        label: String,
    },
    methods: {
        onClick() {
            this.$emit('click');
        },
    },
};
</script>

<style scoped>
.start-test-btn {
    height: 42px;
    background-color: var(--cute-color);
    color: white;
    border-radius: var(--border-radius);
    padding: 1.7rem;
    text-transform: uppercase;
}

.start-test-btn:hover {
    background-color: rgb(228, 112, 3);
}

.start-test-btn:active {
    background-color: rgb(204, 99, 1);
}

@media only screen and (max-width: 600px) {
    .start-test-btn > h3 {
        font-size: 20px !important;
    }
}
</style>
